"use client";

import { useEffect } from "react";
import { addRecentView } from "@/lib/recent-views";

export function TrackView({
  slug,
  title,
  nature,
}: {
  slug: string;
  title: string;
  nature?: string;
}) {
  useEffect(() => {
    addRecentView(slug, title, nature);
  }, [slug, title, nature]);
  return null;
}
